export enum SendUpdatesSignalRTypeEnum {
	RequoteProcurement = 1,
	RequoteNational = 2,
	StripePaymentFlow = 3,
	ExportInventory = 4,
	ImportPDFQuote = 5,
	PreQuote = 6,
	RequoteClaim = 7,
	DynamicReport = 8,
	RateImport = 9,
	RequoteItemsMultiClaim = 10,
	BodyshopAiAnalysis = 11,
}
